/**
 * Prüfungs-QS-Status-Helpers — Issue #463
 *
 * Bildet den internen QS-Status-Ablauf für Gutachten-Akten ab:
 *   keine → qs_erforderlich → qs_in_arbeit → qs_korrektur ↔ qs_in_arbeit
 *                                           ↘ qs_freigegeben → keine
 *
 * Nur Gutachten-Akten in Hauptphase 3 nutzen diesen Status. Solange der
 * Status in ('qs_erforderlich', 'qs_in_arbeit', 'qs_korrektur') steht,
 * ist der Wechsel zu Hauptphase 4 (Versand) blockiert.
 */

export type PruefungStatus =
  | 'keine'
  | 'qs_erforderlich'
  | 'qs_in_arbeit'
  | 'qs_korrektur'
  | 'qs_freigegeben';

export const PRUEFUNG_STATUS_VALUES: ReadonlyArray<PruefungStatus> = [
  'keine',
  'qs_erforderlich',
  'qs_in_arbeit',
  'qs_korrektur',
  'qs_freigegeben',
] as const;

export function pruefungStatusLabel(status: PruefungStatus | string | null | undefined): string | null {
  switch (status) {
    case 'qs_erforderlich': return 'QS erforderlich';
    case 'qs_in_arbeit':    return 'QS in Arbeit';
    case 'qs_korrektur':    return 'QS Korrektur';
    case 'qs_freigegeben':  return 'QS freigegeben';
    case 'keine':
    default:
      return null;
  }
}

export function pruefungStatusBadgeClasses(status: PruefungStatus | string | null | undefined): string {
  switch (status) {
    case 'qs_erforderlich': return 'bg-amber-50 text-amber-700 border border-amber-200';
    case 'qs_in_arbeit':    return 'bg-blue-50 text-blue-700 border border-blue-200';
    case 'qs_korrektur':    return 'bg-red-50 text-red-700 border border-red-200';
    case 'qs_freigegeben':  return 'bg-green-50 text-green-700 border border-green-200';
    default:                return 'bg-gray-50 text-gray-500 border border-gray-200';
  }
}

export function istPruefungBlockierend(status: PruefungStatus | string | null | undefined): boolean {
  return (
    status === 'qs_erforderlich' ||
    status === 'qs_in_arbeit' ||
    status === 'qs_korrektur'
  );
}

export const PRUEFUNG_STATUS_OPTIONEN: ReadonlyArray<{ value: PruefungStatus; label: string }> = [
  { value: 'keine',          label: 'Keine QS' },
  { value: 'qs_erforderlich',label: 'QS erforderlich' },
  { value: 'qs_in_arbeit',   label: 'QS in Arbeit' },
  { value: 'qs_korrektur',   label: 'Korrektur erforderlich' },
  { value: 'qs_freigegeben', label: 'QS freigegeben' },
] as const;
